module.exports = __webpack_public_path__ + "static/Casablanca-7be2a1d22bf1c02b13de25e15f23b9dc.jpg";